import React, { useState } from 'react'
import * as UIcons from '@iconscout/react-unicons'
import StatCard from 'components/DetailWidgets/StatCard'
import MultiLineChartCard from 'components/DetailWidgets/MultiLineChartCard'
import RankedDonutCard from 'components/DetailWidgets/RankedDonutCard'
import TabTable from '../TabTable'

const COLUMNS = [
  { key: 'branch', label: 'Branch' },
  { key: 'location', label: 'Location' },
  { key: 'participants', label: 'Participants' },
  { key: 'sales', label: 'Sales' },
  { key: 'growth', label: 'Growth' },
  {
    key: 'status',
    label: 'Status',
    render: (row) => (
      <span className={`px-2 py-0.5 rounded text-xs font-medium ${row.status === 'Active' ? 'bg-success bg-opacity-10 text-success' : 'bg-body-text bg-opacity-10 text-body-text'}`}>
        {row.status}
      </span>
    )
  }
]

const STATUS_OPTIONS = [
  { label: 'All statuses', value: '' },
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' }
]

export default function BranchTab({ campaign }) {
  const { branch } = campaign
  const [chartTab, setChartTab] = useState(branch.performance.tabs[0].key)

  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {
          branch.stats.map((stat) => (
            <StatCard key={stat.key} icon={UIcons.UilMapMarker} label={stat.label} value={stat.value} trend={stat.trend} tone={stat.tone} />
          ))
        }
      </div>

      <MultiLineChartCard
        title="Branch Performance"
        series={branch.performance.seriesByTab[chartTab]}
        tabs={branch.performance.tabs}
        activeTab={chartTab}
        onTabChange={setChartTab}
      />

      <RankedDonutCard
        title="Sales by Branch"
        centerLabel={branch.branchSales.centerLabel}
        centerValue={branch.branchSales.centerValue}
        data={branch.branchSales.data}
      />

      <TabTable
        columns={COLUMNS}
        rows={branch.rows}
        searchPlaceholder="Search by branch name"
        searchKeys={['branch', 'location']}
        statusOptions={STATUS_OPTIONS}
      />
    </div>
  )
}
